import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Typography } from '@material-ui/core';
import { setModalStatus } from 'redux/slices/modal.slice';
import { usePatchInterestFree } from 'hooks/admin.hook';

const SetInterestFreePanel = () => {
  const { interestPayload } = useSelector(state => state.discounts);

  const { mutate, isLoading } = usePatchInterestFree();

  const dispatch = useDispatch();

  const onAcceptHandler = () => {
    const { checked, ...rest } = interestPayload;
    mutate({ ...rest });
  };

  const onCancelHandler = () => {
    dispatch(
      setModalStatus({
        name: 'SET_INTEREST_FREE',
        isActive: false,
      }),
    );
  };

  return (
    <Box>
      <Typography>
        ¿Deseas {interestPayload.data.isActive ? 'activar' : 'desactivar'} los
        MSI de esta sección?
      </Typography>
      <Box
        mt={2}
        display="flex"
        alignItems="center"
        justifyContent="space-evenly"
      >
        <Button
          variant="contained"
          color="primary"
          onClick={onAcceptHandler}
          disabled={isLoading}
        >
          Aceptar
        </Button>
        <Button variant="outlined" color="primary" onClick={onCancelHandler}>
          Cancelar
        </Button>
      </Box>
    </Box>
  );
};

export default SetInterestFreePanel;
